var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cmp_upload_file"},[_c('section',[_c('i',{staticClass:"el-icon-upload2"}),_c('input',{staticClass:"inputFile",attrs:{"type":"file"},on:{"change":_vm.fileChange}})]),_c('p',[_vm._v(" 上传我的练习图片 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }